import React,{useEffect, useState} from 'react'
import { ImCancelCircle } from "react-icons/im";
import BeatLoader from "react-spinners/BeatLoader";
import ErrorMessage from "../../form/components/ErrorMessage/ErrorMessage";
import Form from "../../form/components/Form/Form";
import * as Yup from "yup";
import FormField from "../../form/components/FormField/FormField";
import Button from "../../form/components/Button/Button";
import TextInput from "../../form/Textinput";
import "./EditCaseModal.css"
import { db } from '../../../firebase/firebase-config';
import { Firestore } from '@firebase/firestore';
import { firebaseApp } from '../../../utils/firebaseConfig';
import { collection, addDoc, updateDoc, doc, serverTimestamp } from "firebase/firestore";
import { toast } from "react-toastify";


function EditCaseModal({ onClose, item, onUpdateDone }: any) {
    const [classes, setClasses] = useState([]);
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);


    const validationSchema = Yup.object().shape({
        case_id: Yup.string(),
        patient_name:Yup.string(),
    });

    const [personalCase, setPersonalCase] = useState("");
    const [specimentCollectionProcedure, setSpecimentCollectionProcedure] = useState("");
    const [currentTreatmentOrHormones, setCurrentTreatmentOrHormones] = useState("");
    const [otherRelevantHistory, setOtherRelevantHistory] = useState("");
    const [relevantClinicalFindings, setRelevantClinicalFindings] = useState("");
    const [maritalStatus, setMaritalStatus] = useState("");
    const [gender, setGender] = useState('');
    const [grossSpecimenDescription, setGrossSpecimenDescription] = useState("");

    const [initialValues, setInitialValues] = useState({
        case_id: item.case_id,
        category: item?.category,
        gender: item?.gender,
        label: item?.label,
        name: item?.name,
        number_of_slides: item?.number_of_slides,
        patient_name: item?.patient_name,
        patient_dob: item?.patient_dob,
        preparation_process: item?.preparation_process,
        referring_physician: item?.referring_physician,
        speci_collection_date_time: item?.speci_collection_date_time,
        specimen_origin: item?.specimen_origin,
        slide_code: item?.slide_code,
        patient_phone: item?.phone,
        type_of_stain: item?.type_of_stain,
        hospital:item?.hospital,
        lab_collection_date_time: item?.lab_collection_date_time,
        about_specimen: item?.about_specimen,
        aspect_of_the_cervix: item?.aspect_of_the_cervix,
        sampling_technique: item?.sampling_technique,
        last_menstrual_period: item?.last_menstrual_period,
        number_of_pregnancies: item?.type_of_stain,
        number_of_deliveries: item?.number_of_deliveries,
        number_of_abortions: item?.number_of_abortions,
        age_at_first_sexual_intercourse: item?.age_at_first_sexual_intercourse,
        age_at_first_childbirth: item?.age_at_first_childbirth,
        clinical_diagnosis: item?.clinical_diagnosis,
        number_of_children_alive: item?.number_of_children_alive,
        number_of_premature_birth: item?.number_of_premature_birth,
        //NEW
        region: item?.region,
        town: item?.town,
        home_address: item?.home_address,
        patient_id: item?.patient_id,
        date_of_sampling: item?.date_of_sampling,
    });
    
    const override = {
    marginTop: "20px",
    };
      
    function removeUndefinedOrNullProperties(obj: any) {
        for (const key in obj) {
          if (obj[key] === undefined || obj[key] === null) {
            delete obj[key];
          }
        }
      }

    const handleSubmit = async(values:any) => {
        try {
          // removeUndefinedOrNullProperties(values);
          //   console.log("EDIT VALUES: ", values)
          //   return;
            // console.log('ACTUAL ITEM: ', item)
            setLoading(true);
            const docRef = doc(collection(db,"Cases"),item?.name)
          
            removeUndefinedOrNullProperties(values);
            await updateDoc(docRef, {
                ...values,
                isPersonal: personalCase == "none" ? "No" : personalCase,
                speciment_collection_procedure: specimentCollectionProcedure,
                current_treatment_or_hormones: currentTreatmentOrHormones,
                other_relevant_history: otherRelevantHistory,
                relevant_clinical_findings: relevantClinicalFindings,
            });

            if(values?.patient_phone || values?.patient_name || values?.patient_dob || values?.gender|| values?.gender) {
              const docRef2 = doc(collection(db,"Patients"),item?.patient_id)
              removeUndefinedOrNullProperties(values);
              await updateDoc(docRef2, {
                displayName: values?.patient_name?.length > 0 ? values?.patient_name : "",
                gender: values?.gender?.length > 0 ? values?.gender : "",
                phoneNumber: values?.patient_phone?.length > 0 ? values?.patient_phone : "",
                dob: values?.patient_dob?.length > 0 ? values?.patient_dob : "", 
            });
            }
            onUpdateDone();
            toast.success("Case updated successfully", {
                pauseOnHover: false,
                closeOnClick: true,
            });
            setLoading(false);
            onClose();
        } catch (error) {
            setLoading(false);
            console.log('ERROR', error)
            toast.error("Error updating case", {
                pauseOnHover: false,
                closeOnClick: true,
            });
        }
    }

    const createNewPatient = async(data:any) =>{
      // const uid = fire.collection('dummy').doc().id; 
      const patientCollectionRef = collection(db,"Patients")
      // Generate random UID for the new document
      try {
          const res = await addDoc(patientCollectionRef,{
            createdAt: serverTimestamp(),
            displayName: data.name,
            email:"",
            gender: data.gender,
            phoneNumber: data.phone,
            dob: data.dob,
            is_verified: false, 
          });

          await updateDoc(res,{uid: res.id})
          
          // console.log("Patient document created and updated successfully") 
          
          return res.id

        } catch (e) {

          // console.error("Error creating and updating patient document ", e);
          return null
        }

    }


    const createNewCase = async(data:any) =>{
      // const uid = fire.collection('dummy').doc().id; 
      const caseCollectionRef = collection(db,"Cases")
      // Generate random UID for the new document

      try {
          const res = await addDoc(caseCollectionRef,{
            category:"Pathology",
            createdAt: serverTimestamp(),
            doctor_uid:null,
            is_case_resolved:false,
            label: "PATHO",
            patient_uid:"",
            subscription_id:null,
            subscription_status: false,
            ...data
          });

          // await updateDoc(newDocRef,{uid: newDocRef.id})

          console.log("Case document created successfully"+ res.id) 
          toast.success("Case document created successfully", {
            pauseOnHover: false,
            closeOnClick: true,
          });

          onClose()
          // return newDocRef.id
        } catch (e) {
          console.error("Error creating and updating patient document ", e);
          toast.error("Error creating new case", {
            pauseOnHover: false,
            closeOnClick: true,
          });
          // return null
        }
    }

    useEffect(() => {
      // console.log('PERSONAL ON LOAD: ', item?.isPersonal)
      // console.log('PERSONAL ON LOAD: ', item)
      if(item?.isPersonal == 'Yes'){
        setPersonalCase('Yes')
      }else {
        setPersonalCase('No')
      }
      if(item?.speciment_collection_procedure) {
        setSpecimentCollectionProcedure(item?.speciment_collection_procedure)
      }
      if(item?.current_treatment_or_hormones){
        setCurrentTreatmentOrHormones(item?.current_treatment_or_hormones)
      }
      if(item?.other_relevant_history){
        setOtherRelevantHistory(item?.other_relevant_history);
      }
      if(item?.relevant_clinical_findings) {
        setRelevantClinicalFindings(item?.relevant_clinical_findings)
      }
      if(item?.marital_status){
        setMaritalStatus(item?.marital_status);
      }

      if(item?.gross_specimen_description){
        setGrossSpecimenDescription(item?.gross_specimen_description)
      }

      if(item?.gender){
        setGender(item?.gender);
      }

        // console.log('ITEM: ',  item);
    },[item])

  return (
    <>
    <div id="case_modal" className="add-case-modal modal-container">
    <div className="modal-head">
      <p className="modal-title">Edit Case</p>
      <ImCancelCircle
        style={{ cursor: "pointer" }}
        onClick={onClose}
        size={22}
        color="#fff"
      />
    </div>
    <div id="case_modal_content" className="modal-content">
    <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <BeatLoader
              color="#3080ED"
              loading={loading}
              cssOverride={override}
            />
          </div>
        
        <form action="" className="auth-form">
        {error && <ErrorMessage error={error} visible={true} />}

        <Form
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}
              
            >

            <div id="case_form_container">
              <p className="label-text">Personal Case: </p>
                <select
                  style={{ borderRadius: 5, padding: 10, height: "50px" }}
                  onChange={(e: any) => {
                    setPersonalCase(e.target.value);
                  }}
                  className="select-field-modal"
                  value={personalCase}
                >
                  <option value="none" selected={true}>
                    None
                  </option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

              <h3 className="form-section-title">Specimen Identification Information</h3>
              <div className="form-section-container">
                  <div className="left_column">

                  <p className="label-text">Patient Name: </p>
                    <FormField
                      name="patient_name"
                      type="text"
                      placeholder="Patient Name"
                    />

                  <p className="label-text">
                      Gender:{" "}
                    </p>
                    <select
                      style={{ borderRadius: 5, padding: 10, height: "50px" }}
                      onChange={(e: any) => {
                        setGender(e.target.value);
                      }}
                      className="select-field-modal"
                      value={gender}
                    >
                      <option value="" selected={true}>
                        None
                      </option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                    {/* <p className="label-text">Gender: </p>
                    <FormField name="gender" type="text" placeholder="Gender" /> */}

                  <p className="label-text">Town: </p>
                    <FormField
                      name="town"
                      type="text"
                      placeholder="Town"
                    />

                    <p className="label-text">
                      Marital Status:{" "}
                    </p>
                    <select
                      style={{ borderRadius: 5, padding: 10, height: "50px" }}
                      onChange={(e: any) => {
                        setMaritalStatus(e.target.value);
                      }}
                      value={maritalStatus}
                      className="select-field-modal"
                    >
                      <option value="" selected={true}>
                        None
                      </option>
                      <option value="Married">Married</option>
                      <option value="Single">Single</option>
                    </select>

                <p className="label-text">Case Id: </p>
                    <FormField
                      name="case_id"
                      type="text"
                      placeholder="Case Id"
                    />

             

                

                    <p className="label-text">Hospital: </p>
                    <FormField
                      name="hospital"
                      type="text"
                      placeholder="Hospital"
                    />

                
              <p className="label-text">Patient Phone: </p>
                    <FormField
                      name="patient_phone"
                      type="number"
                      placeholder="Phone Number"
                    />



                  </div>

                  <div className="right_column">
                  <p className="label-text">Date of Birth: </p>
                    <FormField
                      name="patient_dob"
                      type="date"
                      placeholder="Date of Birth"
                    />

           
<p className="label-text">Region: </p>
                    <FormField
                      name="region"
                      type="text"
                      placeholder="Region"
                    />

              
<p className="label-text">Home address: </p>
                    <FormField
                      name="home_address"
                      type="text"
                      placeholder="Home Address"
                    />

                 <p className="label-text">Patient ID: </p>
                    <FormField
                      name="patient_id"
                      type="text"
                      placeholder="Patient ID"
                    />

                <p className="label-text">Date of sampling: </p>
                    <FormField
                      name="date_of_sampling"
                      type="date"
                      placeholder="Date of sampling"
                    />


                  <p className="label-text">Referring Physician: </p>
                    <FormField
                      name="referring_physician"
                      type="text"
                      placeholder="Referring Physician"
                    />




                  </div>
                </div>
          

                <h3 className="form-section-title">History</h3>
                <div className="form-section-container">
                  <div className="left_column">
                  <p className="label-text">Number Of Pregnancies: </p>
                    <FormField
                      name="number_of_pregnancies"
                      type="number"
                      placeholder="Number of pregnancies"
                    />

                  <p className="label-text">Number Of Abortions: </p>
                    <FormField
                      name="number_of_abortions"
                      type="number"
                      placeholder="Number of abortions"
                    />

                 <p className="label-text">Number of children alive: </p>
                    <FormField
                      name="number_of_children_alive"
                      type="number"
                      placeholder="Number of children alive"
                    />

                  <p className="label-text">Age At First Childbirth: </p>
                    <FormField
                      name="age_at_first_childbirth"
                      type="number"
                      placeholder="Age at first childbirth"
                    />

                  <p className="label-text">Current treatment/Hormones: </p>
                    <select
                      style={{ borderRadius: 5, padding: 10, height: "50px" }}
                      onChange={(e: any) => {
                        setCurrentTreatmentOrHormones(e.target.value);
                      }}
                      className="select-field-modal"
                      value={currentTreatmentOrHormones}
                    >
                      <option value="" selected={true}>
                        None
                      </option>
                      <option value="IUD">IUD</option>
                      <option value="Pills">Pills</option>
                      <option value="other">Other</option>
                    </select>

                  </div>

                  <div className="right_column">

                  <p className="label-text">Number Of Term Deliveries: </p>
                    <FormField
                      name="number_of_deliveries"
                      type="number"
                      placeholder="Number of term deliveries"
                    />


                  <p className="label-text">Number of premature births: </p>
                    <FormField
                      name="number_of_premature_birth"
                      type="number"
                      placeholder="Number of premature births"
                    />

                  <p className="label-text">
                      Age At First Sexual Intercourse:{" "}
                    </p>
                    <FormField
                      name="age_at_first_sexual_intercourse"
                      type="number"
                      placeholder="Age at first sexual intercourse"
                    />


                  <p className="label-text">Last Menstrual Period: </p>
                    <FormField
                      name="last_menstrual_period"
                      type="date"
                      placeholder="Last Menstrual Period"
                    />

                  <p className="label-text">Other Relevant History: </p>
                    <textarea
                      rows={8}
                      onChange={(e: any) => {
                        setOtherRelevantHistory(e.target.value);
                      }}
                      value={otherRelevantHistory}
                      className="textarea"
                    ></textarea>

                  </div>
                </div>

                <h3 className="form-section-title">About Specimen</h3>
                <div className="form-section-container">
                  <div className="left_column">
                  <p className="label-text">About Specimen: </p>
                    <FormField
                      name="about_specimen"
                      type="text"
                      placeholder="About Specimen"
                    />

                  <p className="label-text">
                      Speciment Collection Procedure:{" "}
                    </p>
                    <select
                      style={{ borderRadius: 5, padding: 10, height: "50px" }}
                      onChange={(e: any) => {
                        setSpecimentCollectionProcedure(e.target.value);
                      }}
                      value={specimentCollectionProcedure}
                      className="select-field-modal"
                    >
                      <option value="" selected={true}>
                        None
                      </option>
                      <option value="blood_sample">Blood Sample</option>
                      <option value="FNAB">FNAB</option>
                      <option value="core_biopsy">Core Biopsy</option>
                      <option value="surgical_specimen">
                        Surgical specimen
                      </option>
                      <option value="swab">Swab</option>
                      <option value="pap">PAP</option>
                      <option value="smear">Smear</option>
                      <option value="other">Other</option>
                    </select>

                  </div>

                  <div className="right_column">
                  <p className="label-text">
                      Aspect of the cervix (if applicable):{" "}
                    </p>
                    <FormField
                      name="aspect_of_the_cervix"
                      type="text"
                      placeholder="Aspect of the cervix"
                    />

                  </div>
                </div>

                <h3 className="form-section-title">Clinical Information</h3>
                <div className="form-section-container">
                  <div className="left_column">

                  <p className="label-text">Relevant Clinical Findings: </p>
                    <textarea
                      rows={8}
                      onChange={(e: any) => {
                        setRelevantClinicalFindings(e.target.value);
                      }}
                      value={relevantClinicalFindings}
                      className="textarea"
                    ></textarea>

                  </div>

                  <div className="right_column">
            

                  </div>
                </div>

                <h3 className="form-section-title">Preparation Process</h3>
                <div className="form-section-container">
                  <div className="left_column">
                    <p className="label-text">Type of Stain: </p>
                      <FormField
                        name="type_of_stain"
                        type="text"
                        placeholder="Type of Stain"
                      />
                  </div>

                  <div className="right_column">
            

                  </div>
                </div>

                <h3 className="form-section-title">SAMPLING TECHNIQUE</h3>
                <div className="form-section-container">
                  <div className="left_column">
                    <p className="label-text">Sampling Technique: </p>
                      <FormField
                        name="sampling_technique"
                        type="text"
                        placeholder="Sampling Technique"
                      />


                  <p className="label-text">Gross specimen description: </p>
                    <textarea
                      rows={8}
                      onChange={(e: any) => {
                        setGrossSpecimenDescription(e.target.value);
                      }}
                      value={grossSpecimenDescription}
                      className="textarea"
                    ></textarea>
                  </div>

                  <div className="right_column">
            

                  </div>
                </div>
              
              </div>

                <br /> 
                <br /> 

              {!loading && (
                <Button
                  isOutLined={true}
                  isFullWidth={false}
                  title="SAVE UPDATE"
                />
              )}


        </Form>

        </form>




    </div>
    </div>
    <div className="modal-overlay"></div>
    </>
  )
}

export default EditCaseModal